import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AprobarRechazarInformeRepository } from 'src/app/domain/service/aprobar-rechazar-informe/aprobar-rechazar-informe-repository';
import { InformeCumplimiento } from 'src/app/domain/model/informe/informe-cumplimiento';
import { CausaRechazo } from 'src/app/domain/model/aprobar-rechazar-informe/causa-rechazo';
import { OffsetPageResponse } from 'src/app/domain/model/common/offset-page-response.dto';
import {
  AprobarInformesRequest,
  BuscarInformesEnviadosRequest,
  RechazarInformesRequest,
  ResultadoOperacion
} from 'src/app/domain/model/aprobar-rechazar-informe/aprobar-rechazar-request';

@Injectable({ providedIn: 'root' })
export class HttpAprobarRechazarInformeRepository implements AprobarRechazarInformeRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/aprobar-rechazar-informe`;

  async buscar(request: BuscarInformesEnviadosRequest): Promise<OffsetPageResponse<InformeCumplimiento>> {
    return firstValueFrom(
      this.http.post<OffsetPageResponse<InformeCumplimiento>>(`${this.baseUrl}/buscar`, request)
    );
  }

  async listarCausasRechazo(): Promise<CausaRechazo[]> {
    const response = await firstValueFrom(
      this.http.get<CausaRechazo[]>(`${this.baseUrl}/causas-rechazo`)
    );
    return response ?? [];
  }

  async rechazar(request: RechazarInformesRequest): Promise<ResultadoOperacion> {
    return firstValueFrom(
      this.http.post<ResultadoOperacion>(`${this.baseUrl}/rechazar`, request)
    );
  }

  async aprobar(request: AprobarInformesRequest): Promise<ResultadoOperacion> {
    return firstValueFrom(
      this.http.post<ResultadoOperacion>(`${this.baseUrl}/aprobar`, request)
    );
  }

  async consultarUrlPanorama(cdpanoramas: string): Promise<{ url: string }> {
    return firstValueFrom(
      this.http.get<{ url: string }>(`${this.baseUrl}/panoramas/${encodeURIComponent(cdpanoramas)}/url`)
    );
  }
}
